import map from 'lodash/map'
import gql from 'graphql-tag'

import { COMMENT_PARTS } from './fragments'
import apolloClient from '@/vendor/apollo'

export function getComments ({ objectiveId, keyResultId }) {
  return apolloClient.query({
    query: gql`
      query GetComments (
        $objectiveId: Int,
        $keyResultId: Int
      ) {
        messages(
          objective_id: $objectiveId
          keyresult_id: $keyResultId
        ) {
          edges {
            node {
              ...CommentParts
            }
          }
        }
      }
      ${COMMENT_PARTS}
    `,
    variables: {
      objectiveId,
      keyResultId
    }
  }).then(res => map(res.data.messages.edges, 'node'))
}
